import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SearchQueryContainer = styled.div<React.CSSProperties>`
  left: 0;
  position: absolute;
  overflow: hidden;
  top: ${Screen.widthRatio * 315}px;
`;

export default SearchQueryContainer;
